import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Alert,
} from 'reactstrap';
import { Col, Row, Button, Label, Input } from 'reactstrap';
import './numero-externo.style.css';
import SelectComponent from '@componentes/select/select.component';
import IntlMessage from '../../../../../../helpers/intlMessage';
import { useIntl } from 'react-intl';

const NumeroExternoModalPage = (props) => {
  const intl = useIntl();

	function translate(key) {
	  return intl.formatMessage({ id: key });
	}
  return (
  <div className='numero-externo-container'>
    <Modal
      centered
      isOpen={props.modalExcluir}
      toggle={() => props.toggleModalExcluir()}
    >
      <ModalHeader toggle={() => props.toggleModalExcluir()}>
        <IntlMessage id = "dashboards.examDetail.deleteExternalDocument"/>
      </ModalHeader>
      <ModalBody>
        {props.frascoExterno && (
          <FormGroup>
            <Alert color='danger'>
              <i className='fas fa-exclamation-circle'></i>
              {'  '}
              {`Está ação também irá excluir o frasco ${props.frascoExterno.dsFrasco}`}
              {props.qtdBloco > 0 ? `, ${props.qtdBloco} bloco(s)` : ''}
              {props.qtdLamina > 0 ? `, ${props.qtdLamina} lâmina(s)` : ''}
              {' que está(ão) associado(s) a este documento externo'}
            </Alert>
          </FormGroup>
        )}
        <FormGroup>
          <Label><IntlMessage id = "dashboards.examDetails.justification"/></Label>
          <Input
            type='textarea'
            value={props.justificativa}
            onChange={(e) => props.onChangeJustificativa(e.currentTarget.value)}
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color='secondary' onClick={() => props.toggleModalExcluir()}>
          <IntlMessage id = "dashboards.examDetails.cancel"/>
        </Button>
        <Button
          color='primary'
          onClick={() => {
            props.excluir();
          }}
          disabled={props.justificativa === ''}
        >
           <IntlMessage id = "dashboards.examDetails.confirm"/>
        </Button>{' '}
      </ModalFooter>
    </Modal>
    <Modal size='lg' isOpen={props.isOpen} toggle={props.toggle}>
      <ModalHeader toggle={props.toggle}>
        <IntlMessage id = "dashboards.examDetail.receiptUsingExternalExam"/>
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col className='input-numero-externo' style={{ maxWidth: '30%' }}>
            <Label><IntlMessage id = "dashboards.examDetail.externalExamNumber"/></Label>
            <Input
              style={{ textTransform: 'uppercase' }}
              onChange={(evt) => props.onChange('inputNumeroExterno', evt)}
              value={props.inputNumeroExterno}
              maxLength={15}
              type='text'
              disabled={!!props.NumeroExterno && !props.modoDeEdicao}
            ></Input>
          </Col>
          <Col className='input-qtd'>
            <Label><IntlMessage id = "dashboards.examDetails.block"/></Label>
            <Input
              onChange={(evt) => props.onChange('qtdBloco', evt)}
              value={props.qtdBloco}
              type='number'
              disabled={!!props.NumeroExterno && !props.modoDeEdicao}
            ></Input>
          </Col>
          <Col className='input-qtd'>
            <Label><IntlMessage id = "dashboards.examDetails.blade"/></Label>
            <Input
              onChange={(evt) => props.onChange('qtdLamina', evt)}
              value={props.qtdLamina}
              type='number'
              disabled={!!props.NumeroExterno && !props.modoDeEdicao}
            ></Input>
          </Col>
          <Col style={{ maxWidth: '30%' }}>
            <Label><IntlMessage id = "dashboards.general.topography"/></Label>
            <SelectComponent
              options={props.topografias}
              onChange={(evt) => props.onChange('topografia', evt)}
              placeholder={translate("dashboards.examDetail.selectTopography")}
              value={props.topografia}
              disabled={!!props.NumeroExterno && !props.modoDeEdicao}
            />
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        {props.modoDeEdicao && (
          <Button color='success' onClick={props.atualizarNumeroExterno}>
            <IntlMessage id = "dashboards.examDetail.update"/>
          </Button>
        )}
        {!!props.NumeroExterno && !props.modoDeEdicao && (
          <Button color='warning' onClick={props.alterarModoDeEdicao}>
            <IntlMessage id = "dashboards.examDetail.edit"/>
          </Button>
        )}
        {!!props.NumeroExterno && (
          <Button color='danger' onClick={props.toggleModalExcluir}>
            <IntlMessage id = "dashboards.examDetail.deleteExternalExam"/>
          </Button>
        )}
        <Button color='secondary' onClick={props.toggle}>
          <IntlMessage id = "dashboards.examDetail.close"/>
        </Button>
        <Button
          color='secondary'
          onClick={() => props.gravarNumero(true)}
          disabled={
            props.inputNumeroExterno === '' ||
            props.statusRecebimento === 'realizado'
          }
        >
          <IntlMessage id = "dashboards.examDetail.savePending"/>
        </Button>
        <Button
          color='primary'
          onClick={() => props.gravarNumero(false)}
          disabled={
            props.inputNumeroExterno === '' ||
            props.statusRecebimento === 'realizado'
          }
        >
          <IntlMessage id = "dashboards.examDetail.finalize"/>
        </Button>
      </ModalFooter>
    </Modal>
  </div>
);
}

export default NumeroExternoModalPage;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/material/tabs/numeroExterno/numero-externo.page.js